import React from 'react';

export default function SubscriptionManagement() {
  return (
    <div className="family-tree-container">
      <h1 className="page-title">Subscription Management</h1>
      <p className="text-gray-600">Manage platform subscriptions from this section.</p>
    </div>
  );
}
